export const AppData = [
  "E-commerce platform",
  "CRUD",
  "Todo",
  "Food delivery",
  "Simple Management system",
  "Complex Management system",
  "Language Translator",
  "Reservation Platform",
  "Fitness Tracking Platform",
  "Chatbot",
  "Automation System",
  "Budgeting Platform",
  "Social networking platform",
  "Travel related Platform",
  "Chat App",
  "Calculator",
  "Blogging platform",
  "Authentication System",
  "API data fetch",
  "Portfolio",
  "Job portal",
  "Real Estate Platform",
  "Stock Market Platform",
  "Online learning platform",
  "Streaming Platform",
  "Gaming Platform",
  "Booking system",
  "Crowdfunding Platform",
  "Recommendation System",
  "Personalized Suggestor",
  "Investment Platform",
  "Event Planning System",
  "Robo Advisory Financial Platform",
  "Others"
];
